<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition-all duration-300 ease-out"
      leave-active-class="transition-all duration-300 ease-out"
      enter-from-class="translate-y-full"
      leave-to-class="translate-y-full">
      <button
        v-show="showMobileFlupje"
        :aria-label="`Scroll naar '${title}'`"
        type="button"
        class="lg:hidden fixed bottom-0 left-4 right-4 z-40 bg-white text-primary-100 px-[18px] py-3 rounded-t-lg shadow-lg flex flex-col items-center gap-2 text-sm font-medium"
        @click="scrollToBar">
        <Typography as="span" variant="header-6" class="text-center">
          <div v-html="title"/>
        </Typography>
        <ChevronDownIcon class="w-[11px]" />
      </button>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { useStickyBarVisibility } from '@corporate/composables/useStickyBarVisibility'
import { ChevronDownIcon } from '@gro-up/ui/icons'
import { Typography } from '@gro-up/ui/primitives'

defineProps<{ title?: string }>()

const { showMobileFlupje } = useStickyBarVisibility()

const scrollToBar = () => {
  document.getElementById('sticky-bar-anchor-mobile')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
}
</script>
